import PropTypes from "prop-types";
import React, { useState } from "react";
import { useField, useFormikContext } from "formik";
import PhoneNumber from "material-ui-phone-number";
import { Tooltip } from "../Tooltip";

const PhoneNumberInput = ({
  name,
  inputProps,
  disabled,
  tooltip,
  ...textFieldProps
}) => {
  const [{ value }, { error }, { setValue }] = useField(name);

  const { submitCount, isSubmitting } = useFormikContext(name);
  const [focused, setFocused] = useState(false);

  const showError = !!error && submitCount > 0;

  const phoneNumberField = (
    <PhoneNumber
      variant="filled"
      fullWidth
      helperText={showError && error}
      value={value}
      onChange={setValue}
      InputProps={{
        onBlur: () => setFocused(false),
        inputProps
      }}
      InputLabelProps={{ shrink: !!value || focused }}
      onFocus={() => setFocused(true)}
      error={showError && !!error}
      disabled={isSubmitting || disabled}
      {...textFieldProps}
      disableCountryCode={true}
      defaultCountry="us"
      disableDropdown={true}
      onlyCountries={["us"]}
      isValid={() => true} // Workaround for https://github.com/alexplumb/material-ui-phone-number/issues/60
    />
  );

  return !!tooltip ? (
    <Tooltip title={tooltip}>{phoneNumberField}</Tooltip>
  ) : (
    phoneNumberField
  );
};

PhoneNumberInput.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string
};

PhoneNumberInput.defaultProps = {
  placeholder: "",
  inputProps: {}
};

export default PhoneNumberInput;
